import { Link, useLocation } from 'react-router-dom';
import DefaultDrawer from '../defaultDrawer/DefaultDrawer';
import { useModal } from '../../../../contexts/modalsContext/modalsContext';
import './NavigationDrawer.scss';
import useTranslation from '../../../../hooks/translation/useTranslation';
import LanguageSelector from '../../../customerRoute/components/LanguageSelector';
import { ReactComponent as HotLineDesktop } from '../../../../../resources/images/svg/hotLineDesktop.svg';
import { ReactComponent as HotLineMobile } from '../../../../../resources/images/svg/hotLineMobile.svg';
import useQuery from '../../../../hooks/useQuery';
import infoContentList from '../../../../../utils/constants/infoContentList';

const authorizeButtonClass = 'border-0 bg-transparent text-black hover:text-primary ease-out duration-300 cursor-pointer flex gap-[10px] items-center hover-icon font-big text-lg';

function NavigationDrawer() {
  const query = useQuery();
  const { showNavigationDrawer, setShowNavigationDrawer } = useModal();
  const { trans, currentLanguage, configInfo } = useTranslation();
  const activeTab = query.get('tab');
  const location = useLocation();
  const isGeorgia = configInfo?.countryCode === 'GE';

  const handleCloseDrawer = () => {
    setShowNavigationDrawer(false);
  };

  const handleScroll = () => {
    const drawer = document.querySelector('.nav-drawer-wrapper');
    const drawerBody = drawer.querySelector('.ant-drawer-body');
    if (drawerBody) {
      drawerBody.scrollTo({
        top: drawerBody.scrollHeight,
        behavior: 'smooth',
      });
    }
  };

  return (
    <DefaultDrawer
      show={showNavigationDrawer}
      setShow={setShowNavigationDrawer}
      style={{
        maxHeight: 493,
        height: '100%',
      }}
      wrapperStyle={{
        height: 410,
      }}
      className="nav-drawer"
      wrapperClassName="nav-drawer-wrapper"
    >
      <button
        type="button"
        onClick={handleScroll}
        className="h-8 w-8 bg-primary border-none rounded-full absolute z-10 flex items-center justify-center bottom-10 right-5"
      >
        <div className="arrow white w-3 h-3 rotate-45 translate-y-[-2px]" />
      </button>
      <ul className="flex flex-col gap-3">
        {(isGeorgia ? infoContentList.ge : infoContentList.am).items.map(({
          key, label, labels, Icon, muted, isDefault,
        }) => {
          const isActive = isDefault
            ? ((activeTab === key || !activeTab) && location.pathname === `/${currentLanguage}/info-content`)
            : activeTab === key;
          return (
            <Link
              key={key}
              onClick={handleCloseDrawer}
              to={`info-content?tab=${key}`}
              className={`${authorizeButtonClass} ${muted ? 'opacity-70' : ''} ${isActive && 'active'}`}
            >
              {Icon && <Icon className="w-5 h-5" />}
              {labels ? labels.map((l, i) => (
                <span key={l}>
                  {i > 0 && '/'}
                  {trans(l)}
                </span>
              )) : trans(label)}
            </Link>
          );
        })}
      </ul>
      <div className="w-full flex items-center justify-between pt-5 pl-10 gap-5">
        <LanguageSelector />
        <a
          href="tel:1331"
          className="flex gap-4 items-center"
        >
          <HotLineMobile className="h-9 mt-[19px]" />
          <HotLineDesktop className="h-10" />
        </a>
      </div>
    </DefaultDrawer>
  );
}

export default NavigationDrawer;
